import Stack from '@mui/material/Stack';
import { JuicyTypography } from '../../components/index.ts';
import { Keyboard } from '../../features/index.ts';
import { PageBackButton } from '../../components/button/pageBackButton.tsx';
import { NextPageButton } from '../../components/button/NextPageButton.tsx';
import { Path } from '../../assets/enums/index.ts';
import { useNavigate } from 'react-router';
import { useCallback, useMemo, useState } from 'react';
import { Typography, useTheme } from '@mui/material';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';
import { getStackSx } from './styles.ts';

const _codeLength = 4;
const keys = new Array(_codeLength).fill(0).map((_, i) => ({
  id: i,
}));
export const PhoneConfirmationPage = () => {
  const theme = useTheme();
  const { palette } = theme;
  const nav = useNavigate();
  const { gameSessionParams, setParams } = useGameSessionContext();
  const [code, setCode] = useState('');


  const onNextPageButtonClick = useCallback(() => {
    setParams({ code });
    nav(gameSessionParams.isFreeTraining ? Path.StartGame : Path.PaymentMethod);
  }, [setParams, code, nav, gameSessionParams]);

  const isNextPageButtonDisabled = useMemo(() => {
    return code.length < _codeLength;

  }, [code]);

  return (
    <Stack height={'100%'} pt={20} pb={14}>
      <JuicyTypography mb={30}>A quick verification to keep things secure</JuicyTypography>
      <Stack direction="row" gap={6} alignItems="stretch" height={223}>
        {keys.map((el, i) => {
          const value = code[i] ?? '.';
          const isActive = code.length === i;
          const isFilled = value !== '.';
          let typographyTransformValue = 'unset';

          if (!isFilled) {
            typographyTransformValue = 'translateY(-15px)';
            if (isActive) {
              typographyTransformValue = 'translateY(-25px)';
            }
          }

          const withBorder = isActive || isFilled;

          return (
            <Stack
              key={i}
              sx={getStackSx(theme, withBorder)}
            >
              <Typography
                variant={isActive ? 'accent' : 'title'}
                color={palette.dark}
                sx={{
                  transform: typographyTransformValue,
                }}
              >
                {value}
              </Typography>
            </Stack>
          );
        })}
      </Stack>

      <Typography
        variant="body"
        mt={25}
        mb={43}
        color={palette.accent}
        textAlign={'center'}
        width={'100%'}>
        Verification
        code sent to
        {' '}{gameSessionParams.phoneNumber}</Typography>

      <Keyboard mt="auto" onClearButtonClick={() => {
        setCode(value => value.slice(0, value.length - 1));
      }} onKeyClick={(key) => {
        if (code.length < _codeLength) {
          setCode(value => value + key);
        }
      }} />

      <Stack width="100%" direction={'row'} alignItems={'center'} gap={8} mt={20}>
        <PageBackButton onClick={() => nav(Path.Phone)} />
        <NextPageButton disabled={isNextPageButtonDisabled} onClick={onNextPageButtonClick}>Continue</NextPageButton>
      </Stack>
    </Stack>
  );
};
